import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'product_info-product_details_variant_selection-click';

/**
 * Tracks retailer clicks for different variations available for selection, under Product Details Page
Parameter 1: option selector type
*/
export function trackProductInfoProductDetailsVariantSelectionClick(
  customParameterToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { customParameterToken },
  });
}
